import qs from 'query-string';
import type { ContestCreateResponse } from '@betterpool/api-types/contests-service';

import { nextApiAuthServiceInstance } from '~/domains/services/nextApi.instance';
import { contestsServiceInstance } from '~/domains/contest/domains/services/contest.service.instance';
import type { BRANDS } from '~/domains/auth/consts';

import type { APISection } from '../common/sections/types';
import type { APIField } from '../common/fields/types/main';
import type { QueryParams } from '../common/api/settings/types/query.params';

type SectionsResponse = {
  sections: APISection[];
};

export const getRestartNew = async (queryParams: QueryParams) => {
  const queryString = `?${qs.stringify(queryParams)}`;
  const response = await nextApiAuthServiceInstance.get<SectionsResponse>(
    `/contest/restart/new${queryString}`
  );

  return response.data?.sections ?? [];
};

export const getRestartContestData = async (contestId: string, brand: BRANDS) => {
  const response = await contestsServiceInstance.get(
    `/contest-metadata/${contestId}/restart-contest-data?brand=${brand}`
  );

  return response.data;
};

export const getRestartEndpointData = async <
  R extends APIField | APIField[] | APISection | APISection[],
>(
  endpoint: string,
  payload: Record<string, any>,
  method: 'GET' | 'POST' = 'GET',
  abortController?: AbortController,
  queryParams?: QueryParams
): Promise<R> => {
  const queryString = `?${qs.stringify(queryParams)}`;

  const response = await nextApiAuthServiceInstance.request<R>({
    url: `/contest/restart/${endpoint}${queryString}`,
    signal: abortController?.signal,
    method,
    ...(method === 'GET'
      ? {
          params: payload,
        }
      : {
          data: payload,
        }),
  });

  return response.data;
};

export const postRestartContest = async (payload: Record<string, unknown>) => {
  const response = await nextApiAuthServiceInstance.post<ContestCreateResponse>(
    '/contest/restart/new',
    payload
  );

  return response.data;
};
